import React, { useEffect, useRef, useState } from 'react';
import Close from '../../_styles/images/close-icon-green.svg';


export default function PriceDisclaimerPopup(props) {
  const node = useRef();
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);

  function updatePDPKeydown(e) {
    if (e.which === 13) {
      props.updatePDPopup(false)
    }
  }

  useEffect(() => {
    if (node && node.current) {
      const button = document.getElementById('close-button-popup');
      button?.focus();
    }
  }, [])

  useEffect(() => {
    const focusableElements = modalRef.current?.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    function handleKeyDown(event) {
      if (event.key === 'Escape') {
        props.updatePDPopup(false);
      }
      if (event.key === 'Tab') {
        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    closeButtonRef.current?.focus(); // Move focus to close button when modal opens

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [props.updatePDPopup]);

  return (
    <div
      className="charges-popup show"
      id="price-disclaimer-popup"
      role="dialog"
      aria-modal="true"
      aria-labelledby="price-disclaimer-header"
      aria-describedby="price-disclaimer-content"
      ref={modalRef}
    >
      <div className="price-container">
        <div className="price-disclaimer-container">
          <div className="sp-header">
            <h2 className="header" id="price-disclaimer-header">
              Recurring subscription.<br/>Rates subject to change.
            </h2>
            <button
              id="close-button-popup"
              className="close"
              onClick={() => props.updatePDPopup(false)}
              tabIndex={0}
              aria-label="Close price disclaimer popup"
              ref={closeButtonRef}
            >
              <img src={Close} alt="Close" />
            </button>
          </div>
          <div id="price-disclaimer-content" className="price-disclaimer-popup-container">
            <p className="content">
              Displayed monthly rate includes a monthly recurring subscription. Monthly rate is subject to change, and includes estimated fuel, tolls, add-on equipment, and certain taxes. Displayed rate does not include other optional or non-recurring fees such as key replacement, cleaning, and re-fueling. Depending on your state, your monthly rate may not include certain variable state taxes. You may cancel online or by telephone with 30 days prior notice. Your Commute with Enterprise Participant Agreement will include full details.
            </p>
          </div>
          <div className="button-container">
            <button className="continue-button" onClick={() => props.updatePDPopup(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
